import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { IAppointment } from './programari.interface';

@Injectable({
    providedIn: 'root'
})
export class ProgramariService {
    private token!: string;
    private httpOptions: any;

    private basePath = environment.interop.basePath;

    private listDTProgramariURL =
        this.basePath +
        environment.interop.platform.nomenclatoare.ghiseulUnic.programari.listDT;

    public printListProgramariURL =
        this.basePath +
        environment.interop.platform.nomenclatoare.ghiseulUnic.programari.printList;

    public listScheduleProgramariURL =
        this.basePath +
        environment.interop.platform.nomenclatoare.ghiseulUnic.programari.schedule;

    private exportExcelURL =
        this.basePath +
        environment.interop.platform.nomenclatoare.ghiseulUnic.programari.exportExcel;

    constructor(private http: HttpClient) { }

    listDTProgramari() {
        return this.http.post(this.listDTProgramariURL, {});
    }

    listSchedule(payload: any) {
        return this.http.post<{ errors: boolean; data: IAppointment[]; status_code: number }>(
            this.listScheduleProgramariURL, payload
        );
    }

    exportExcel(payload: any): Observable<Blob> {
        return this.http.post(this.exportExcelURL, payload, {
            headers: this.httpOptions?.headers,
            responseType: 'blob' as 'json',
        }) as Observable<Blob>;
    }

    setToken(token: string) {
        this.token = token;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${this.token}`,
            }),
        };
    }
}
